import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import classNames from "classnames";

import {addBoxError, searchLicencePlate} from '../actions';
import BoxTitle from '../components/BoxTitle';
import BoxInput from '../components/BoxInput';
import BoxValidateButton from '../components/BoxValidateButton';
import {onElementAppear, onElementExit} from '../utils'
import {Flipped} from "react-flip-toolkit";

class LicencePlateBox extends Component{
    constructor(props) {
        super(props);

        this.state = {
            searchValue : ""
        }
    }

    handleInputChange(e) {
        this.setState({searchValue: e.target.value.toUpperCase()});
    }

    handleKeyPress(e) {
        if(e.keyCode == 13){
            this.validate();
        }
    }

    handleValidate() {
        this.validate();
    }

    validate() {
        this.props.searchLicencePlate(this.state.searchValue);
    }

    renderError() {
        if (!this.props.statuses.licencePlate.error) {
            return null;
        }

        return (
            <span className="error">
                    {this.props.statuses.licencePlate.error}
            </span>
        );
    }

    render() {
        let bActive=this.props.activeTab === 'licence_plate';
        const containerClasses = classNames(
            'licence_plate_box',
            {
                'active' : bActive
            }
        );

        return (
            <Flipped
                flipId={`licence_plate_box`}
                onDelayedAppear={onElementAppear}
                onExit={onElementExit}
                key={`licence_plate_box`}
                delay={3}
                translate
                opacity>
                <div className={containerClasses}>
                    <BoxTitle title="Renseignez votre plaque d'immatriculation"/>{/*numéro de*/}
                    {this.renderError()}
                    <div className="form_input_group">
                        <span>
                            <i className={"europe_stars"}>&nbsp;</i>
                            <p>&nbsp;F</p>
                        </span>
                        <BoxInput size="9" changeAction={(e) => this.handleInputChange(e)} keyDownAction={(e) => this.handleKeyPress(e)} placeholder={"BJ-246-PS"} autoFocus={false} value={this.state.searchValue}/>
                        <span></span>
                        <BoxValidateButton clickAction={(e) => this.handleValidate()}/>
                    </div>
                    {this.props.statuses.licencePlate.loading ? <div className="loading"></div> : null}
                </div>
            </Flipped>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        vehicle:state.vehicle,
        partCategory:state.partCategory,
        statuses:state.boxStatuses
    }
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        searchLicencePlate
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LicencePlateBox)